export const addonSum = (addons = []) => addons.reduce((s, a) => s + a.price, 0);
export const lineTotal = (it) => (it.price + addonSum(it.addons)) * it.qty;
export const hasOptions = (item) => item.addons?.length > 0 || item.variant_groups?.length > 0;
export const unitPrice = (item, variants = []) =>
  variants.length ? variants[0].price + variants.slice(1).reduce((s, v) => s + v.price, 0) : item.price;
export const cartKey = (itemId, addons = [], variants = []) =>
  addons.length || variants.length
    ? `${itemId}:${variants.map((v) => v.id).join(",")}|${addons.map((a) => a.id).sort().join(",")}`
    : itemId;
